import { VideoGame } from "@/interfaces/api";
import queryClient from "@/lib/queryClient";
import { useState } from "react";
import { useGetToken } from "./token";

const getGames = async (q: string) => {
  const response = await fetch(`/api/get-games?q=${q}`);
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  const data: VideoGame[] = await response.json();
  return data;
};

export const useGetGames = () => {
  const { data, refetch } = useGetToken();

  const [result, setResult] = useState<VideoGame[]>([]);
  const [fetching, setFetching] = useState(false);

  const searchGames = (q: string) => {
    if (!data?.hasToken) refetch();

    queryClient
      .fetchQuery({
        queryKey: ["getGames", q],
        queryFn: async () => {
          setFetching(true);
          const result = getGames(q);
          return result;
        },
      })
      .then((res) => {
        setResult(res);
      })
      .finally(() => setFetching(false));
  };

  return { result, searchGames, fetching };
};
